module.exports = __webpack_public_path__ + "img/schedule-logo-active.7dabfccd.svg";